import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";

/**
 * @param {{
 *  options: Array<{ id: number; text: string }>;
 *  values: string[];
 *  onChange: (values: string[]) => void;
 * }} param0
 */
export function Choices({ options, values, onChange }) {
  var handleChange = (nextOption) => {
    if (values?.includes(nextOption)) {
      onChange(values?.filter((value) => value !== nextOption) || []);
    } else {
      onChange([nextOption, ...(values || [])]);
    }
  };

  return (
    <div className={styles.root}>
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => handleChange(option.text)}
          className={cx(styles.option, {
            [styles.active]: values?.find((v) => v === option.text),
          })}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
}
